export const CARRIER_ROLE_LABEL = { admin: 'Administrator', dispatcher: 'Dispatcher', driver: 'Sjåfør' };

export const LICENSE_CLASSES = ['B', 'BE', 'C1', 'C1E', 'C', 'CE', 'D1', 'D1E', 'D', 'DE'];

// Hvilke roller en bruker i org-en kan invitere eller opprette (speiler functions/src/carrierOrg.js og carrierPeople.js)
export const inviteRolesFor = (role) => (role === 'admin' ? ['driver', 'dispatcher', 'admin'] : ['driver']);
export const createRolesFor = (role) => (role === 'admin' ? ['driver', 'dispatcher'] : ['driver']);

export const isStaffRole = (role) => role === 'admin' || role === 'dispatcher';
